export default "__VITE_ASSET__20a501c2__"